<template>
  <bscroll-view>
    <div class="result-content-wrapper">
      <div id="searchResult">
        <div class="prompt-title">
          {{ langTransfer(`为您找到“${$route.params.keyWord}”相关结果：`) }}
        </div>

        <div class="result-content">
          <div class="left">
            <section v-if="magazineData">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(magazineData.name) }}
                </h5>
                <button
                  @click="numShowMth()"
                  v-if="magazineData.list.length >= 12"
                >
                  {{ langTransfer(numShow ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list magazine-list">
                  <div
                    v-for="(item, index) in numShow
                      ? magazineData.list.slice(0, 12)
                      : magazineData.list"
                    :key="index"
                    class="resource-item magazine-item"
                    @click="detailDispatcher('magazine', item, 2)"
                  >
                    <div
                      class="
                        hb-resource-cover
                        lr-img-scale lr-high-light lr-magazine-cover
                      "
                    >
                      <img :src="item.poster" />
                    </div>
                    <p class="name text1line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section class="article-result">
              <!-- 文章 -->
              <div class="article-result-header">
                <p class="updateClass">
                  <span v-if="articleList && articleList.records != ''">{{
                    langTransfer(`共搜到${articleList.total || 0}篇文章`)
                  }}</span>
                </p>
                <div class="article-type-mask">
                  <div
                    v-for="(item, index) in articleType"
                    :key="index"
                    :style="{
                      background:
                        index === checkedArticleTypeIndex ? '#303133' : '',
                      color: index === checkedArticleTypeIndex ? '#fff' : '',
                    }"
                    class="article-type-item"
                    @click="changeArticleType(index)"
                  >
                    {{ langTransfer(item.name) }}
                  </div>
                </div>
              </div>
              <div class="list-body-wrap" style="min-height: 900px">
                <div
                  v-if="
                    JSON.stringify(articleList) != '[]' && articleList !== null
                  "
                  class="PhilosophyWarp"
                >
                  <ul>
                    <li
                      v-for="(item, index) in articleList.records"
                      :key="index"
                      @click="go_contentPath(item)"
                    >
                      <template v-if="checkedArticleTypeIndex === 0">
                        <h6>
                          {{ item.Title }}
                        </h6>
                        <p v-html="langTransfer(item.Summary)" />
                        <span>
                          {{ item.MagazineName }} {{ item.Year }}年{{
                            `0${item.Issue}`.substr(-2)
                          }}期 | {{ item.Columns }} 作者：{{ item.Author }}
                        </span>
                      </template>
                      <template v-if="checkedArticleTypeIndex === 1">
                        <h6>
                          {{ item.Title }}
                        </h6>
                        <p v-html="langTransfer(item.Summary)" />
                        <span>
                          {{ item.BookName }}
                          {{ item.Author ? `| 作者：${item.Author}` : "" }}
                        </span>
                      </template>
                      <template v-if="checkedArticleTypeIndex === 2">
                        <h6>
                          {{ item.title }}
                        </h6>
                        <p>
                          {{ item.describes }}
                        </p>
                        <span v-if="item.author_name">
                          {{ item.author_name }}
                        </span>
                      </template>
                      <template v-if="checkedArticleTypeIndex === 3">
                        <h6>
                          {{ item.title }}
                        </h6>
                        <p>
                          {{ item.note }}
                        </p>
                        <span>
                          {{ item.sourceName }}
                          {{ item.author ? `| 作者：${item.author}` : "" }}
                        </span>
                      </template>
                      <template v-if="checkedArticleTypeIndex === 4">
                        <h6 v-html="item.Title" />
                        <p>
                          {{ item.ColumnName }}
                        </p>
                        <span>
                          {{ item.Columns }}
                          {{ item.Author ? `| 作者：${item.Author}` : "" }}
                        </span>
                      </template>
                    </li>
                  </ul>

                  <pagination
                    style="margin: 30px 0"
                    :current-page="totalnum.page"
                    :rows="totalnum.pageSize"
                    :total="totalnum.total"
                    @handleCurrentChangeSub="noChangePagination"
                  />
                </div>

                <emptyContent
                  v-show="
                    Array.isArray(searchResultList) &&
                    Array.isArray(articleList) &&
                    JSON.stringify(searchResultList) == '[]' &&
                    JSON.stringify(articleList) == '[]'
                  "
                  con-text="暂无搜索结果"
                />
              </div>
            </section>
          </div>
          <div class="right">
            <section v-if="bookData">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(bookData.name) }}
                </h5>
                <button @click="numShowMthT()" v-if="bookData.list.length >= 8">
                  {{ langTransfer(numShowT ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list book-list">
                  <div
                    v-for="(item, index) in numShowT
                      ? bookData.list.slice(0, 8)
                      : bookData.list"
                    :key="index"
                    class="resource-item book-item"
                    @click="
                      detailDispatcher('book', item, 'searchResultIndexMax')
                    "
                  >
                    <div
                      class="
                        hb-resource-cover
                        lr-img-scale lr-high-light lr-book-cover
                      "
                    >
                      <img :src="item.poster" />
                    </div>
                    <p class="name text2line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="assemblyBook">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(assemblyBook.name) }}
                </h5>
                <button
                  @click="numShowMthTr()"
                  v-if="assemblyBook.list.length >= 8"
                >
                  {{ langTransfer(numShowTh ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list book-list">
                  <div
                    v-for="(item, index) in numShowTh
                      ? assemblyBook.list.slice(0, 8)
                      : assemblyBook.list"
                    :key="index"
                    class="resource-item book-item"
                    @click="detailDispatcher('assemblyBook', item)"
                  >
                    <div
                      class="
                        hb-resource-cover
                        lr-img-scale lr-high-light lr-book-cover
                      "
                    >
                      <img :src="item.poster" />
                    </div>
                    <p class="name text2line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="audioData">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(audioData.name) }}
                </h5>
                <button
                  @click="numShowMthF()"
                  v-if="audioData.list.length >= 8"
                >
                  {{ langTransfer(numShowF ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list audio-list">
                  <div
                    v-for="(item, index) in numShowF
                      ? audioData.list.slice(0, 8)
                      : audioData.list"
                    :key="index"
                    class="resource-item audio-item"
                    @click="detailDispatcher('audio', item)"
                  >
                    <div class="hb-resource-cover cover lr-img-scale">
                      <img :src="item.poster" />
                      <!-- <img class="play-icon" src="@/assets/img/play.png"> -->
                    </div>
                    <p class="name text2line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="videoData">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(videoData.name) }}
                </h5>
                <button
                  @click="numShowMthFi()"
                  v-if="videoData.list.length >= 6"
                >
                  {{ langTransfer(numShowFi ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list video-list">
                  <div
                    v-for="(item, index) in numShowFi ? videoData.list.slice(0, 6) : videoData.list"
                    :key="index"
                    class="resource-item video-item"
                    @click="detailDispatcher('video', item)"
                  >
                    <div class="hb-resource-cover cover lr-img-scale">
                      <img :src="item.poster" />
                      <!-- <img class="play-icon" src="@/assets/img/play.png"> -->
                    </div>
                    <p class="name text1line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="knowledgeBookData">
              <div class="resource-list-header">
                <h5>
                  {{ langTransfer(knowledgeBookData.name) }}
                </h5>
                <button @click="numShowMthS()"
                  v-if="knowledgeBookData.list.length >= 8">
                  {{ langTransfer(numShowS ? "展开" : "折叠") }}
                </button>
              </div>
              <div class="list-wrapper">
                <div class="resource-list knowledge-book-list">
                  <div
                    v-for="(item, index) in numShowS ? knowledgeBookData.list.slice(0, 8) : knowledgeBookData.list"
                    :key="index"
                    class="resource-item knowledge-book-item"
                    @click="
                      detailDispatcher(
                        'knowledgeBook',
                        item,
                        'searchResultIndexMax'
                      )
                    "
                  >
                    <div
                      class="
                        hb-resource-cover
                        lr-img-scale lr-high-light lr-magazine-cover
                      "
                    >
                      <img :src="item.poster" />
                    </div>
                    <p class="name text1line">
                      {{ langTransfer(item.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <footer-com />
    </div>
  </bscroll-view>
</template>

<script>
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";
import pictureList from "@/components/common/pictureList/pictureList.vue"; //公共组件 图片列表
import audioCon from "@/components/common/audio_video/audioCon.vue"; //音频列表
import videoCon from "@/components/common/audio_video/videoCon.vue"; //视频列表
import emptyContent from "@/components/emptyContent/emptyContent.vue"; //无内容
import { homeSearchResultList } from "@/api/lxc";
import { searchAndDailyUpdateArticle, searchJournalArticle } from "@/api/hb";
import pagination from "@/components/common/pagination/index.vue";

export default {
  name: "SearchResult",
  components: {
    BscrollView,
    FooterCom,
    emptyContent,
    pagination,
  },
  data() {
    return {
      numShow: true,
      numShowT: true,
      numShowTh: true,
      numShowF: true,
      numShowFi: true,
      numShowS: true,
      searchResultList: null,
      articleList: null,
      articleListdata: [],
      page: {
        page: 1,
        pageSize: 12,
        total: 0,
      },
      endScreen: false,
      checkedArticleTypeIndex: 0,
      articleType: [
        {
          val: "magazine",
          name: "期刊",
        },
        {
          val: "book",
          name: "图书",
        },
        {
          val: "knowledge",
          name: "知识库",
        },
        {
          val: "knowledgeBook",
          name: "知识书",
        },
        {
          val: "knowledgeBook",
          name: "汇编书屋",
        },
      ],
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    totalnum() {
      return this.page;
    },
    magazineData() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 1;
      });
    },
    bookData() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 3;
      });
    },
    assemblyBook() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 15;
      });
    },
    audioData() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 4;
      });
    },
    videoData() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 5;
      });
    },
    knowledgeBookData() {
      const { searchResultList } = this;
      if (!searchResultList) {
        return null;
      }
      return searchResultList.find((e) => {
        return e.type === 8;
      });
    },
  },
  watch: {
    // '$route.query.searchKey': function () {
    //     this.homeSearchResultListFn()
    //     this.getArticles()
    // },
    "$route.params.keyWord": function () {
      this.homeSearchResultListFn();
      this.getArticles();
    },
    webInfo(newVal) {
      if (newVal.service_code) {
        this.homeSearchResultListFn();
        this.getArticles();
      }
    },
    // endScreen(n) {
    //   if (n == true) {
    //     this.getDailyList();
    //   }
    // }
  },
  created() {
    // 监听页面的滚动事件
    // window.onscroll = () => {
    //   this.endScreen = this.screenCheck();
    // };
  },
  mounted() {
    const { service_code } = this.webInfo;
    if (service_code) {
      this.homeSearchResultListFn();
      this.getArticles();
    }
  },
  methods: {
    numShowMth() {
      this.numShow = !this.numShow;
    },
    numShowMthT() {
      this.numShowT = !this.numShowT;
    },
    numShowMthTr() {
      this.numShowTh = !this.numShowTh;
    },
    numShowMthF() {
      this.numShowF = !this.numShowF;
    },
    numShowMthFi() {
      this.numShowFi = !this.numShowFi;
    },
    numShowMthS() {
      this.numShowS = !this.numShowS;
    },
    noChangePagination(res) {
      this.bookList = [];
      this.page.page = res;
      this.getArticles();
    },
    itemClickHandler(item) {
      console.log(item);
      const { href } = this.$router.resolve({
        path: "/occupationBookDetail",
        query: {
          id: item.id,
        },
      });
      window.open(href, "_blank");
    },
    go_contentPath(item) {
      const { checkedArticleTypeIndex } = this;
      let href;
      if (checkedArticleTypeIndex === 0) {
        this.detailDispatcher("magazineArticle", item, "theSearch");
        // href = this.$router.resolve({
        //   name: "bookpagedetails",
        //   query: {
        //     type: "1",
        //     id: item.TitleID,
        //     resourceName: item.MagazineName,
        //     resourceId: item.MagazineGuid,
        //     year: item.Year,
        //     issue: item.Issue,
        //   },
        // }).href;
      } else if (checkedArticleTypeIndex === 1) {
        this.detailDispatcher("book", item, "searchResultIndex");

        // href = this.$router.resolve({
        //   name: "bookpagedetails",
        //   query: {
        //     type: "3",
        //     id: item.TitleID,
        //     bookId: item.BookGuid,
        //   },
        // }).href;
      } else if (checkedArticleTypeIndex === 2) {
        console.log(item);
        const { href } = this.$router.resolve({
          name: "knowledgeLibArticle",
          params: {
            id: item.unique_code,
            secParentId: item.author_unique_code,
          },
        });
        window.open(href, "_blank");
      } else if (checkedArticleTypeIndex === 3) {
        this.detailDispatcher("knowledgeBook", item, "searchResultIndex");
      } else {
        this.detailDispatcher("assemblyBook", item, "searchResultIndex");
        // href = this.$router.resolve({
        //   name: "levelFourCatalog",
        //   params: {
        //     id: item.unique_code,
        //     parentId: item.author_unique_code,
        //   },
        // }).href;
      }
      if (href) {
        window.open(href, "_blank");
      }
    },
    async homeSearchResultListFn() {
      try {
        this.searchResultList = null;
        const data = await homeSearchResultList({
          service_code: this.webInfo.service_code,
          key: this.$route.params.keyWord,
        });
        this.searchResultList = data;
      } catch (err) {
        this.searchResultList = [];
      }
    },
    changeArticleType(index) {
      if (this.checkedArticleTypeIndex === index) {
        return;
      }
      this.checkedArticleTypeIndex = index;
      this.page = {
        page: 1,
        pageSize: 12,
        total: 0,
      };
      this.getArticles();
    },
    getArticles() {
      const { checkedArticleTypeIndex } = this;
      if (checkedArticleTypeIndex === 0) {
        this.getMagazineSearch();
      } else if (checkedArticleTypeIndex === 1) {
        this.getMagazineSearch(2);
      } else if (checkedArticleTypeIndex === 3) {
        this.getMagazineSearch(4);
      } else if (checkedArticleTypeIndex === 4) {
        this.getMagazineSearch(15);
      } else {
        this.getKnowledgeArticles();
      }
    },
    async getMagazineSearch(type) {
      try {
        this.articleList = null;
        const data = await searchJournalArticle({
          service_code: this.webInfo.service_code,
          key: this.$route.params.keyWord,
          page: this.page.page,
          pageSize: this.page.pageSize,
          type: type || 1,
        });
        this.articleList = data;
        // this.articleListdata = this.articleListdata.concat(data.records);
        this.page.total = data.total;
      } catch (err) {
        this.articleList = [];
      }
    },
    async getKnowledgeArticles() {
      try {
        this.articleList = null;
        const data = await searchAndDailyUpdateArticle({
          type: 2,
          service_code: this.webInfo.service_code,
          key: this.$route.params.keyWord,
          page: this.page.page,
          pageSize: this.page.pageSize,
        });
        this.articleList = data;
        this.page.total = data.total;
      } catch (err) {
        this.articleList = [];
      }
    },
    isJson(obj) {
      const isjson =
        typeof obj === "object" &&
        Object.prototype.toString.call(obj).toLowerCase() ==
          "[object object]" &&
        !obj.length;
      return isjson;
    },
  },
};
</script>

<style scoped lang="less">
.result-content-wrapper {
  width: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#searchResult {
  width: 1200px;
  padding-bottom: 10px;

  .prompt-title {
    width: 1200px;
    height: 24px;
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 24px;
    margin: 30px 0 10px;
  }

  .result-content {
    width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .left,
  .right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    section {
      width: 100%;
      margin-bottom: 20px;
    }
  }

  .left {
    width: 720px;
  }

  .right {
    width: 432px;
  }

  .resource-list-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h5 {
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 24px;
    }

    button {
      height: 24px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
    }
  }

  .resource-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .magazine-item {
    width: 105px;
    margin-right: 18px;
    margin-bottom: 20px;

    &:nth-child(6n) {
      margin-right: 0;
    }

    .hb-resource-cover {
      width: 105px;
      height: 140px;
      border-radius: 4px;
    }

    .name {
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .book-item {
    width: 96px;
    margin-right: 16px;
    margin-bottom: 20px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .hb-resource-cover {
      width: 96px;
      height: 128px;
      border-radius: 4px;
    }

    .name {
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .audio-item {
    width: 96px;
    margin-right: 16px;
    margin-bottom: 20px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .hb-resource-cover {
      width: 96px;
      height: 96px;
      border-radius: 8px;
      position: relative;
    }

    .name {
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .video-item {
    width: 132px;
    margin-right: 16px;
    margin-bottom: 20px;

    &:nth-child(3n) {
      margin-right: 0;
    }

    .hb-resource-cover {
      width: 132px;
      height: 74px;
      border-radius: 8px;
      position: relative;
    }

    .name {
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .knowledge-book-item {
    width: 96px;
    margin-right: 16px;
    margin-bottom: 20px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .hb-resource-cover {
      width: 96px;
      height: 128px;
      border-radius: 4px;
    }

    .name {
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      margin-top: 10px;
    }
  }

  .article-result {
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 0 20px;
  }
}

.article-result-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  height: 62px;
  box-shadow: 0px 0px 0px 0px #e6e6e6;
}

.updateClass {
  font-size: 18px;
  font-family: AlibabaPuHuiTiM;
  color: #303133;
  line-height: 24px;
}

.article-type-mask {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.article-type-item {
  padding: 0 10px;
  line-height: 30px;
  font-size: 13px;
  font-family: AlibabaPuHuiTiM;
  color: #606266;
  background: #f0f2f5;
  border-radius: 15px;
  cursor: pointer;
  margin-left: 24px;
}

.article-type-mask .updateClass {
  padding-bottom: 0;
}

.PhilosophyWarp {
  width: 100%;

  ul {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  li {
    width: 100%;
    padding: 10px 0 20px;
    cursor: pointer;

    h6 {
      width: 100%;
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
    }

    p {
      margin: 4px 0 6px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 24px;
    }

    span {
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 20px;
    }

    &:hover {
      h6 {
        color: #303133;
      }

      p {
        color: #606266;
      }

      span {
        color: #606266;
      }
    }
  }
}
</style>
